import { unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

export function usePolicy() {
  const user = useMapGetter('getCurrentUser');
  const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');
  const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

  const { accountId } = useAccount();

  const getUserPermissionsForAccount = () => {
    return getUserPermissions(user.value, accountId.value);
  };

  // Super admin é papel de plataforma (user.type), não da conta: ele vê todo módulo
  // gated só por flag, ligado ou não NAQUELA conta. Mesma semântica que o guard de rota
  // `superAdminOrFlag` em routes/index.js já aplica na porta da frente. Sem isto, o
  // <Policy> que embrulha cada item do menu escondia PowerAgents e PowerData do super
  // admin em toda conta sem a flag — inclusive nas que ele entrou para configurar.
  // Permissão de papel (checkPermissions) continua vencendo em shouldShow.
  const isSuperAdmin = () => user.value?.type === 'SuperAdmin';

  const isFeatureFlagEnabled = featureFlag => {
    if (!featureFlag) return true;
    if (isSuperAdmin()) return true;
    return isFeatureEnabled.value(accountId.value, featureFlag);
  };

  const checkPermissions = requiredPermissions => {
    if (!requiredPermissions || !requiredPermissions.length) return true;
    const userPermissions = getUserPermissionsForAccount();
    return hasPermissions(requiredPermissions, userPermissions);
  };

  const checkInstallationType = config => {
    if (Array.isArray(config) && config.length > 0) {
      const installationCheck = {
        [INSTALLATION_TYPES.CLOUD]: isOnChatwootCloud.value,
        [INSTALLATION_TYPES.COMMUNITY]: true,
      };

      return config.some(type => installationCheck[type]);
    }

    return true;
  };

  const shouldShow = (featureFlag, permissions, installationTypes) => {
    const flag = unref(featureFlag);
    const perms = unref(permissions);
    const installation = unref(installationTypes);

    // if the user does not have permissions or installation type is not supported
    // return false;
    // This supersedes everything
    if (!checkPermissions(perms)) return false;
    if (!checkInstallationType(installation)) return false;

    return isFeatureFlagEnabled(flag);
  };

  return {
    checkPermissions,
    isFeatureFlagEnabled,
    shouldShow,
  };
}
